import { Grid } from '@mui/material';
import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ClientContactDTO, deleteClientContact } from 'wisestep-api';

import { ConfirmDeleteDialog } from '../../../../components';
import ErrorLogger from '../../../../providers/ErrorLogger';
import { failed, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import {
  EditIconButton,
  DeleteIconButton,
  CloseIconButton,
} from '../../../crmSettings/components/StyledIconButtons';

interface ClientContactListProps {
  clientContacts: ClientContactDTO[];
  handleCancel: () => void;
  handleEdit: (data: ClientContactDTO) => void;
  clientContact: ClientContactDTO;
  refresh: () => void;
}

const ClientContactList = ({
  clientContacts,
  handleCancel,
  handleEdit,
  clientContact,
  refresh,
}: ClientContactListProps) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [clientContactToDelete, setClientContactToDelete] = useState<ClientContactDTO>();

  const handleConfirmation = async (data: ClientContactDTO) => {
    setClientContactToDelete(data);
    setOpenDeleteDialog(true);
  };

  const handleDelete = async () => {
    if (clientContactToDelete?.id) {
      try {
        await deleteClientContact(clientContactToDelete.id);
        setOpenDeleteDialog(false);
        refresh();
        setNotification(success('Client Contact has been deleted successfully !!'));
      } catch {
        setNotification(failed('Something went wrong, Please try again !!'));
      }
    }
  };

  return (
    <>
      {clientContacts?.length > 0 && (
        <Grid container>
          <Grid container py={1} sm={11} ml={6}>
            <Grid item px={1} sm={5}>
              {'Name'}
            </Grid>
            <Grid item px={1} sm={3}>
              {'Email Address'}
            </Grid>
            <Grid item px={1} sm={2.5}>
              {'Position'}
            </Grid>
            <Grid item px={1} sm={1} sx={{ display: 'flex', justifyContent: 'center' }}>
              {'Action'}
            </Grid>
          </Grid>
        </Grid>
      )}
      {clientContacts?.map((val, index) => (
        <Grid container key={index}>
          <Grid item p={1} sm={0.5} sx={{ display: 'flex', justifyContent: 'center' }}>
            {`${index + 1}.`}
          </Grid>
          <Grid container py={1} sm={11}>
            <Grid item px={1} sm={5}>
              {`${val.firstName} ${val.lastName}`}
            </Grid>
            <Grid item px={1} sm={3}>
              {val.emailAddress}
            </Grid>
            <Grid item px={1} sm={2.5}>
              {val.position}
            </Grid>
            <Grid item px={1} sm={1} sx={{ display: 'flex', justifyContent: 'center' }}>
              {clientContact && clientContact.id == val.id ? (
                <>
                  <CloseIconButton onClick={() => handleCancel()} />
                </>
              ) : (
                <>
                  <EditIconButton onClick={() => handleEdit(val)} />
                  <DeleteIconButton onClick={() => handleConfirmation(val)} />
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      ))}
      {openDeleteDialog && (
        <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
          <ConfirmDeleteDialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
            onConfirm={handleDelete}
            deletingItem={`${clientContactToDelete?.firstName}`}
          />
        </ErrorBoundary>
      )}
    </>
  );
};

export default ClientContactList;
